import React, { Fragment, useEffect, useState } from "react";
import imagelogo from "../../assets/images/telekom-logo.svg";
// import otelogo from "../../assets/images/auto.svg";
import Navbar from "../NavBar";
import i18next from "i18next";
import menu from "../../assets/images/menu.svg";
import account_icon from "../../assets/images/account.svg";

function Header(props) {
	const { handleOpen, t, payloadAfterLogIn } = props;
	const isTourist = Boolean(payloadAfterLogIn?.isTourist);

	const [headerLanguageToggle, setHeaderLanguageToggle] = useState(false);
	const [stateMobileNavbar, setStateMobileNavbar] =
		useState("navbar-container");
	const [stateOfLang, setStateOfLang] = useState(
		() => sessionStorage.getItem("language") || "gr",
	);

	useEffect(() => {
		const hasTouristFlag = typeof payloadAfterLogIn?.isTourist === "boolean";
		if (!hasTouristFlag) return;

		const storedLanguage = sessionStorage.getItem("language");
		if (storedLanguage) {
			setStateOfLang(storedLanguage);
			i18next.changeLanguage(storedLanguage);
			return;
		}

		const defaultLanguage = isTourist ? "en" : "gr";
		setStateOfLang(defaultLanguage);
		i18next.changeLanguage(defaultLanguage);
		sessionStorage.setItem("language", defaultLanguage);
	}, [isTourist, payloadAfterLogIn]);

	const changeLangHandler = (val) => {
		i18next.changeLanguage(val);
		setStateOfLang(val);
		sessionStorage.setItem("language", val);
		if (window.location.href.indexOf("packages") > -1) {
			window.location.reload();
		}
	};

	const headerLanguageDropdown = () => {
		setHeaderLanguageToggle(!headerLanguageToggle);
	};

	let temp;
	if (stateOfLang === "en") {
		temp = (
			<a className="languageSelect" onClick={headerLanguageDropdown}>
				<span className="langSelected">
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("en");
							setStateOfLang("en");
						}}
					>
						{t("langEn")}
					</button>
					<i
						className={
							headerLanguageToggle
								? "symmetry-icon-arrow-up"
								: "symmetry-icon-arrow-down"
						}
					></i>
				</span>
				<span
					className={
						headerLanguageToggle
							? "langInactive langText-visible"
							: "langInactive"
					}
				>
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("gr");
							setStateOfLang("gr");
						}}
					>
						Ελληνικά
					</button>
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("ru");
							setStateOfLang("ru");
						}}
					>
						Русский
					</button>
				</span>
			</a>
		);
	} else if (stateOfLang === "gr") {
		temp = (
			<a className="languageSelect" onClick={headerLanguageDropdown}>
				<span className="langSelected">
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("gr");
							setStateOfLang("gr");
						}}
					>
						{t("langGr")}
					</button>
					<i
						className={
							headerLanguageToggle
								? "symmetry-icon-arrow-up"
								: "symmetry-icon-arrow-down"
						}
					></i>
				</span>
				<span
					className={
						headerLanguageToggle
							? "langInactive langText-visible"
							: "langInactive"
					}
				>
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("en");
							setStateOfLang("en");
						}}
					>
						English
					</button>
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("ru");
							setStateOfLang("ru");
						}}
					>
						Русский
					</button>
				</span>
			</a>
		);
	} else if (stateOfLang === "ru") {
		temp = (
			<a className="languageSelect" onClick={headerLanguageDropdown}>
				<span className="langSelected">
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("ru");
							setStateOfLang("ru");
						}}
					>
						{t("langRu")}
					</button>
					<i
						className={
							headerLanguageToggle
								? "symmetry-icon-arrow-up"
								: "symmetry-icon-arrow-down"
						}
					></i>
				</span>
				<span
					className={
						headerLanguageToggle
							? "langInactive langText-visible"
							: "langInactive"
					}
				>
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("en");
							setStateOfLang("en");
						}}
					>
						English
					</button>
					<button
						className="langText"
						onClick={() => {
							changeLangHandler("gr");
							setStateOfLang("gr");
						}}
					>
						Ελληνικά
					</button>
				</span>
			</a>
		);
	}

	return (
		<Fragment>
			<header className="headerContainer">
				<div className="header-elements-container">
					<a href="https://www.cosmote.gr" className="header-title">
						<div className="header-logo">
							<img src={imagelogo} alt="telekom-logo" />
						</div>
					</a>
					<div className="header-right-side">
						<div className="header-user">
							<div className="header-user-details">
								<div className="my-account dropdown cosid_md_login">
									<div className="my-account-dropdown-container">
										<div className="header-user-welcome">
											<div className="header-user-welcome-content">
												{t("welcome")}
												<div className="header-user-id">
													{payloadAfterLogIn.msisdn}
												</div>
											</div>
											<div className="header-user-icon">
												<img src={account_icon} />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="topButtons">{temp}</div>
						<img
							className="burgerIcon"
							onClick={() => {
								setStateMobileNavbar("navbar-container active");
							}}
							src={menu}
						/>
					</div>
				</div>
				<div className="header-separator"></div>
				<Navbar
					temp={temp}
					handleOpen={handleOpen}
					stateMobileNavbar={stateMobileNavbar}
					setStateMobileNavbar={setStateMobileNavbar}
				/>
			</header>
		</Fragment>
	);
}

export default Header;
